import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PencilLine = function PencilLine(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 20.9998h-8m-10.5.5 5.5493-2.1343c.355-.1365.5324-.2048.6984-.2939a3 3 0 0 0 .4203-.2732c.149-.1155.2834-.25.5523-.5189L21 6.9998c1.1046-1.1045 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L5.7203 14.2795c-.269.2689-.4034.4034-.519.5523a3 3 0 0 0-.273.4203c-.0892.166-.1574.3435-.294.6985zm0 0 2.0581-5.351c.1473-.3829.221-.5744.3472-.6621a.5.5 0 0 1 .379-.0804c.151.0288.296.1739.5862.464l2.259 2.2591c.2902.2901.4352.4351.464.5861a.5.5 0 0 1-.0804.379c-.0876.1263-.2791.1999-.662.3472z"
    })
  }));
};
export default PencilLine;